import Layout from './widgets/Layout'
import { DMEAppProps } from './DMEApp'
import InvalidPartsOrderView from './views/InvalidPartsOrderView'

export type DMEInvalidPartsOrderPageProps = Pick<DMEAppProps, 'settings'>

const DMEInvalidPartsOrderPage = ({
  settings,
}: DMEInvalidPartsOrderPageProps) => {
  return (
    <Layout settings={settings}>
      <InvalidPartsOrderView />
    </Layout>
  )
}

export default DMEInvalidPartsOrderPage
